import React from 'react';
import { BarChart, XAxis, YAxis, Bar, ResponsiveContainer } from 'recharts';

const labelFormatter = (value) => {
  return `$${value}`;
};

export const SavingsBarChart = () => {
  const data = [
    { name: 'Condenser', value: '103' },
    { name: 'Cooling Tower', value: '222' },
    { name: 'Glycol', value: '53' },
    { name: 'Hydronic', value: '429' },
    { name: 'Lighting', value: '371' },
    { name: 'Makeup Air', value: '935' },
    { name: 'Primary', value: '67' },
  ];

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart data={data} layout="vertical" barCategoryGap={5} barSize={11}>
        <defs>
          <linearGradient id="colorValue" x1="0" y1="0" x2="1" y2="0">
            <stop offset="5%" stopColor="#af8ce3" />
            <stop offset="95%" stopColor="#9580ea" />
          </linearGradient>
        </defs>
        <XAxis type="number" hide />
        <YAxis type="category" width={130} padding={{ left: 50 }} dataKey="name" axisLine={false} tickLine={false} />
        <Bar
          dataKey="value"
          fill="url(#colorValue)"
          radius={[10, 10, 10, 10]}
          label={{ position: 'right', formatter: labelFormatter }}
          isAnimationActive={true}
        />
      </BarChart>
    </ResponsiveContainer>
  );
};
